import React from 'react';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { darkPlate, slideControlSx } from './slideControlTheme';

// The prev/next arrows sit over the slide itself, on a dark translucent plate
// so a white chevron reads whatever the slide underneath happens to be. The
// hover and focus states come from `darkPlate`, shared with the other controls
// that float over a slide; only the placement is this component's own.
//
// This was a bare <button> with a plain inline `style` object, which cannot
// express a `:hover` rule at all - the same cause as the thumbnail controls in
// #206.
const navButtonSx = (side) => ({
    ...slideControlSx(darkPlate),
    position: 'absolute',
    top: '50%',
    [side]: '0.5rem',
    transform: 'translateY(-50%)',
    zIndex: 10,
    width: '3rem',
    height: '3rem',
    padding: 0,
    color: 'common.white'
});

function SlideNavButtons({ onPrevSlide, onNextSlide, hasPrevSlide = false, hasNextSlide = false }) {
    return (
        <>
            {hasPrevSlide && (
                <IconButton
                    aria-label='Previous slide'
                    onClick={onPrevSlide}
                    sx={navButtonSx('left')}
                >
                    <ChevronLeftIcon />
                </IconButton>
            )}
            {hasNextSlide && (
                <IconButton aria-label='Next slide' onClick={onNextSlide} sx={navButtonSx('right')}>
                    <ChevronRightIcon />
                </IconButton>
            )}
        </>
    );
}

export default SlideNavButtons;
